import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { useUserById } from "@/hooks/users/useUserById";
import { DiagnosticOverviewData } from "@/models/DiagnosticOverviewData";
import { VehicleStatus } from "@/models/VehicleStatusAddInData";

export function VehicleStatusCell(props: GridRenderCellParams<DiagnosticOverviewData>) {
  const status = props.row?.vehicleStatus as VehicleStatus | undefined;
  const { data: user } = useUserById(status?.userId ?? "");
  const { t } = useTranslation();
  const tooltipTitle =
    status && user?.name
      ? t("faultOverview.remarkTooltip", {
          name: user?.name ?? status?.userId,
          date: status?.dateTime ? new Date(status?.dateTime).toLocaleString() : "",
        })
      : "";

  return (
    <Tooltip title={tooltipTitle} arrow>
      <Box
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {props?.formattedValue || "---"}
      </Box>
    </Tooltip>
  );
}
